import { Flow } from '../types'

// "79.00" -> "79", "4.50" -> "4.5"
export function trimPrice(price: string): string {
  return String(Number(price))
}

// Money as shown in the purchase table, e.g. "$79.00".
export function money(value: number): string {
  return `$${value.toFixed(2)}`
}

// The word for a seat in this flow. Parents buy for children; everyone else for students.
export function nounFor(flow: Flow): { one: string; many: string } {
  return flow === 'family'
    ? { one: 'child', many: 'children' }
    : { one: 'student', many: 'students' }
}
